import { useContext } from 'react';
import { ConfigContext } from '../context/ConfigContext';
export function useConfig(key = '') {
    const config = useContext(ConfigContext);
    // Fail fast instead of silently returning {}
    if (config == null) {
        throw new Error('useConfig() was used outside of a <ConfigContext.Provider>. ' +
            'This usually means the library is being bundled/installed twice or React is duplicated.');
    }
    if (!key)
        return config;
    if (typeof key !== 'string') {
        throw new Error(`The configuration key must be a string, received ${typeof key}`);
    }
    // if we are requesting a certain config item, return just that property.
    const keyParts = key.split('.');
    // traverse the config values to find the requested config item
    const configItem = keyParts.reduce((currentObj, key) => {
        if (key in currentObj) {
            return currentObj[key];
        }
        else {
            return undefined;
        }
    }, config);
    return configItem;
}
